/**
 * Identificador único del dispositivo para el control de fraude (`device_unique_identifier`).
 * Se genera una vez y se conserva en `sessionStorage`, así es el mismo en todas las
 * tokenizaciones de la sesión.
 */
const STORAGE_KEY = 'carrefour-iframe-checkout.device-id';

const generateUuid = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const safeSessionStorage = (): Storage | undefined => {
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
};

/** Respaldo cuando no hay `sessionStorage`: el id se mantiene mientras viva la página. */
let memoryId: string | undefined;

export const getDeviceUniqueIdentifier = (storage: Storage | undefined = safeSessionStorage()): string => {
  if (!storage) {
    memoryId ??= generateUuid();
    return memoryId;
  }
  try {
    const stored = storage.getItem(STORAGE_KEY);
    if (stored) {
      return stored;
    }
    const id = generateUuid();
    storage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    memoryId ??= generateUuid();
    return memoryId;
  }
};
